import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Checkbox,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';

class BookingFormTwoItemRowInfo extends Component {
  generateDisplay = (items) => {
    const displayArray = [];
    const {
      divider
    } = this.props;
    for (let i = 0; i < items.length; i += 2) {
      displayArray.push(this.buildTwoItemRows(items[i], items[i + 1]))
    }
    if (divider) {
      displayArray.push(
        <Grid key={`${items[0].label}-grid-divider`} item xs={12}>
          <Divider key={`${items[0].label}-divider`} className="form-divider" />
        </Grid>
      )
    }
    
    return displayArray;
  }

  formatItem = (item) => {
    if (!item) {
      return '';
    }
    return (
      typeof item.value === 'boolean'
      ? <Checkbox disabled checked={item.value} />
      : item.value
    )
  }

  buildTwoItemRows = (item1, item2) =>
    (
      <Fragment key={`${item1.label}-frag`}>
        <Grid key={item1.label} item xs={3} className="bookingFormLabel">
          <Typography key={`${item1.label}-t`} component="div">
            <Box key={`${item1.label}-b`} fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {item1.label}
            </Box>
          </Typography>
        </Grid>
        <Grid key={`${item1.label}-${item1.value}-lv`} item xs={3} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {this.formatItem(item1)}
            </Box>
          </Typography>
        </Grid>
        <Grid key={`${item1.label}-k2`} item xs={3} className="bookingFormLabel">
          <Typography key={`${item1.label}-t2`} component="div">
            <Box key={`${item1.label}-b2`} fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {item2 ? item2.label : ''}
            </Box>
          </Typography>
        </Grid>
        <Grid key={`${item1.label}-${item1.value}-lv2`} item xs={3} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {this.formatItem(item2)}
            </Box>
          </Typography>
        </Grid>
      </Fragment>
    )

  render() {
    const {
      items,
    } = this.props;
    
    return (
      <>
        {this.generateDisplay(items)}
      </>
    )
  }
}

BookingFormTwoItemRowInfo.defaultProps = {
  divider: true,
}

BookingFormTwoItemRowInfo.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  })).isRequired,
  divider: PropTypes.bool,
};

export default BookingFormTwoItemRowInfo;
